var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "#F3F4F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288 205H224L160 141V275.4C160 328.42 202.98 371.4 256 371.4C309.02 371.4 352 328.42 352 275.4V141L288 205ZM216 285C207.16 285 200 277.84 200 269C200 260.16 207.16 253 216 253C224.84 253 232 260.16 232 269C232 277.84 224.84 285 216 285ZM296 285C287.16 285 280 277.84 280 269C280 260.16 287.16 253 296 253C304.84 253 312 260.16 312 269C312 277.84 304.84 285 296 285Z",
    fill: "#B9BECA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_12"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCat);
export default __webpack_public_path__ + "static/media/cat.9abda3c1305223a35345152e2e9b7fab.svg";
export { ForwardRef as ReactComponent };